import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "CustomReply" }

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {getListData} from '@/service/main/system'
import {useStore} from '@/store'
import dayjs from 'dayjs'
import {initEmptyParam} from '@/hooks/useInitParam'
import {ref} from 'vue'
import localCache from "@/utils/cache";


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomReply',
  setup(__props) {

initEmptyParam()
const store = useStore()
const getCompanyList = async () => {
  let corpList = localCache.getCache('companyData')
  const corpOptions = corpList.map((item: any) => {
    return {title: item.name, value: item.id}
  })
  const corpItem = searchFormConfig.formItems.find((item) => item.field === 'corPid')
  corpItem!.options = corpOptions
}
getCompanyList()

const getUsedBy = async () => {
  let userList = await getListData(
    '/main/enterpriseWechat/dingUser/listAll',
    {}
  )
  const userOptions = userList.map((item: any) => {
    return {title: item.userName, value: item.userName}
  })
  const usedByItem = searchFormConfig.formItems.find(
    (item) => item.field === 'usedBy'
  )
  usedByItem!.options = userOptions
}
getUsedBy()

const handleSortChange = (value: any) => {
  console.log(value)
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const formatReplyDual: any = (replyDual: any) => {
  if (!replyDual) {
    return '尚未回复'
  }
  const seconds = Math.floor(replyDual / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)

  const remainingSeconds = seconds % 60
  const remainingMinutes = minutes % 60
  const remainingHours = hours % 24
  return `${days}天${remainingHours}时${remainingMinutes}分${remainingSeconds}秒`
}

const formatColor = (replyDual: any) => {
  if (replyDual) {
    if (replyDual > 24 * 60 * 60 * 1000) {
      return 'red'
    } else if (replyDual > 60 * 60 * 1000) {
      return 'orange'
    } else if (replyDual > 30 * 60 * 1000) {
      return 'darksalmon'
    }
  } else {
    return 'blue'
  }
}

let queryParam = ref()
if (store.state.login.userInfo.isManager != '1') {
  queryParam.value = {
    usedBy: store.state.login.userInfo.realName,
    timeSlot: [
      dayjs().startOf('date').format('YYYY-MM-DD'),
      dayjs().endOf('date').format('YYYY-MM-DD')
    ],
    corPid: '20'
  }
} else {
  queryParam.value = {
    timeSlot: [
      dayjs().startOf('date').format('YYYY-MM-DD'),
      dayjs().endOf('date').format('YYYY-MM-DD')
    ],
    corPid: '20'
  }
}

store.commit('system/changeQueyryInfo', queryParam.value)
const resetCb = () => {
  return queryParam.value
}

const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick,
  handleSummaryBtnClick
] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "customReply",
      downFilename: "客户回复明细表.xlsx",
      summaryFilename: "业务员回复情况汇总.xlsx",
      onSortChange: handleSortChange,
      onDownBtnClick: _unref(handleDownBtnClick),
      onSummaryBtnClick: _unref(handleSummaryBtnClick)
    }, {
      replyDual: _withCtx((scope) => [
        _createElementVNode("div", {
          style: _normalizeStyle({ color: formatColor(scope.row.replyDual) })
        }, _toDisplayString(formatReplyDual(scope.row.replyDual)), 5)
      ]),
      _: 1
    }, 8, ["contentTableConfig", "onDownBtnClick", "onSummaryBtnClick"])
  ]))
}
}

})